import { TableSortOrder } from '../Table';
import { BrowserEntryType } from './ListFileBrowser.constants';
export const getExtensionFromFileName = (name) => {
    const dotIndex = name.lastIndexOf('.');
    const isDotFileOrExtensionless = dotIndex <= 0;
    return isDotFileOrExtensionless
        ? ''
        : name.slice(dotIndex + 1).toLowerCase();
};
export const getBrowserEntryExtension = (entry) => {
    if (entry.type !== BrowserEntryType.FILE) {
        return '';
    }
    return getExtensionFromFileName(entry.name);
};
export const filterBrowserEntriesByName = (entries, searchText) => {
    const needle = searchText.trim().toLocaleLowerCase();
    if (needle === '') {
        return [...entries];
    }
    return entries.filter((entry) => entry.name.toLocaleLowerCase().includes(needle));
};
export const filterBrowserEntriesByType = (entries, entryTypes) => entries.filter((entry) => entryTypes.includes(entry.type));
export const compareBrowserEntriesByName = (a, b) => nameCollator.compare(a.name, b.name);
export const compareBrowserEntriesByType = (a, b) => TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type);
export const compareBrowserEntriesByTypeThenName = (a, b) => compareBrowserEntriesByType(a, b) || compareBrowserEntriesByName(a, b);
export const compareBrowserEntriesByExtension = (a, b) => nameCollator.compare(getBrowserEntryExtension(a), getBrowserEntryExtension(b));
export const compareBrowserEntriesBySize = (a, b) => compareOptionalNumbers(a.size, b.size);
export const compareBrowserEntriesByCreationTime = (a, b) => compareOptionalNumbers(a.creationTime, b.creationTime);
export const compareBrowserEntriesByUpdateTime = (a, b) => compareOptionalNumbers(a.updateTime, b.updateTime);
export const reverseBrowserEntryComparator = (comparator) => (a, b) => comparator(b, a);
export const withDirsFirst = (comparator) => (a, b) => {
    const isADir = a.type === BrowserEntryType.DIR;
    const isBDir = b.type === BrowserEntryType.DIR;
    if (isADir !== isBDir) {
        return isADir ? -1 : 1;
    }
    return comparator(a, b);
};
export const createBrowserEntrySortConfig = (comparator) => ({
    [TableSortOrder.ascending]: comparator,
    [TableSortOrder.descending]: reverseBrowserEntryComparator(comparator),
});
const TYPE_ORDER = [
    BrowserEntryType.DIR,
    BrowserEntryType.FILE,
    BrowserEntryType.LINK,
];
const nameCollator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
});
const compareOptionalNumbers = (a, b) => {
    if (a === undefined || b === undefined) {
        return Number(a !== undefined) - Number(b !== undefined);
    }
    return a - b;
};
